import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function KeyPlayers() {
  const {
    t
  } = useLanguage();
  const players = [{
    name: 'Lionel Messi',
    position: t('players.forward'),
    club: 'Inter Miami',
    number: '10',
    image: 'https://cdn.magicpatterns.com/uploads/qFWPcak9Ea2uNJ9kmvXznV/image.png'
  }, {
    name: 'Julián Álvarez',
    position: t('players.forward'),
    club: 'Atlético Madrid',
    number: '9',
    image: 'https://cdn.magicpatterns.com/uploads/58MRsyMJ538MmDzNPXrjco/image.png'
  }, {
    name: 'Enzo Fernández',
    position: t('players.midfielder'),
    club: 'Chelsea',
    number: '24',
    image: 'https://cdn.magicpatterns.com/uploads/irbxCwBhfmfUHkmJgMswNK/image.png'
  }, {
    name: 'Alexis Mac Allister',
    position: t('players.midfielder'),
    club: 'Liverpool',
    number: '20',
    image: 'https://cdn.magicpatterns.com/uploads/hDeKdEjn3MTSipwWfSsb4z/image.png'
  }, {
    name: 'Dibu Martínez',
    position: t('players.goalkeeper'),
    club: 'Aston Villa',
    number: '23',
    image: 'https://cdn.magicpatterns.com/uploads/7hzuMYsemiH1fAkymrRVG5/image.png'
  }, {
    name: 'Lautaro Martínez',
    position: t('players.forward'),
    club: 'Inter Milan',
    number: '22',
    image: 'https://cdn.magicpatterns.com/uploads/gaEWw5f7nngsvdA9Sna4fp/image.png'
  }];
  return <section className="py-10 md:py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-191">
      <div className="container mx-auto px-4 md:px-12 mb-6 md:mb-12" data-id="element-192">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row md:items-end justify-between gap-4" data-id="element-193">
          <div data-id="element-194">
            <h2 className="text-argentina-blue font-oswald uppercase tracking-widest text-xs md:text-sm font-bold mb-2" data-id="element-195">
              {t('players.label')}
            </h2>
            <h3 className="text-2xl md:text-5xl font-oswald font-bold uppercase" data-id="element-196">
              {t('players.title1')}{' '}
              <span className="text-argentina-gold" data-id="element-197">{t('players.title2')}</span>
            </h3>
          </div>
          <a href="https://www.espn.com/soccer/team/squad/_/id/202/league/FIFA.WORLDQ.CONMEBOL" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm font-oswald uppercase tracking-widest text-gray-400 hover:text-white transition-colors flex items-center gap-2 min-h-[44px]" data-id="element-198">
            {t('players.viewSquad')}{' '}
            <span className="text-argentina-gold" data-id="element-199">→</span>
          </a>
        </motion.div>
      </div>

      {/* Mobile: 2-column grid / Desktop: 6-column grid */}
      <div className="container mx-auto px-4 md:px-12" data-id="element-200">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-6" data-id="element-201">
          {players.map((player, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="group relative rounded-xl md:rounded-2xl overflow-hidden bg-[#111] border border-white/5 hover:border-argentina-blue transition-all duration-500" data-id="element-202">
              <div className="aspect-[3/4] relative overflow-hidden bg-gradient-to-br from-argentina-dark-blue to-argentina-black" data-id="element-203">
                <div className="absolute inset-0 bg-gradient-to-t from-[#111] via-[#111]/50 to-transparent z-10" data-id="element-204"></div>

                {/* Using Unsplash placeholders with a blend mode to make them look like stylized player cards */}
                <img src={player.image} alt={player.name} loading="lazy" decoding="async" className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-700" data-id="element-205" />

                {/* Number Overlay */}
                <div className="absolute top-2 right-2 md:top-3 md:right-3 z-20 font-oswald text-2xl md:text-4xl font-bold text-white/30 group-hover:text-argentina-gold/80 transition-colors duration-300" data-id="element-206">
                  {player.number}
                </div>

                {/* Content */}
                <div className="absolute bottom-0 left-0 w-full p-3 md:p-5 z-20" data-id="element-207">
                  <p className="text-argentina-gold font-oswald uppercase tracking-widest text-[8px] md:text-[10px] mb-0.5" data-id="element-208">
                    {player.position}
                  </p>
                  <h4 className="font-oswald text-sm md:text-xl font-bold uppercase mb-0.5 leading-tight" data-id="element-209">
                    {player.name}
                  </h4>
                  <p className="text-[10px] md:text-xs text-gray-400 font-light" data-id="element-210">
                    {player.club}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}